var render = function render(_c,_vm){return _c('div',{staticClass:"v-card__actions",class:{ 'v-card__actions--center': _vm.props.center }},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }